"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modals = modals;
exports["default"] = void 0;

var _actions = require("./actions");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {};

function modals() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.CLOSE_MODAL:
      document.body.style.position = 'inherit';
      document.body.style.overflow = 'initial';
      return Object.assign({}, state, _defineProperty({}, action.name, {
        contentElement: action.config && action.config.keepComponentMounted ? state[action.name].contentElement : null,
        isActive: false
      }));

    case _actions.SHOW_MODAL:
      document.body.style.position = 'fixed';
      document.body.style.overflow = 'hidden';
      return Object.assign({}, state, _defineProperty({}, action.name, Object.assign({}, state[action.name], {
        config: action.config,
        contentElement: action.element,
        isActive: true
      })));

    default:
      return state;
  }
}

var _default = modals;
exports["default"] = _default;